import { Button } from '../ui';
import { SeverityBadge } from './StatusBadge';

interface AnomalyCardProps {
  id: string;
  metric: string;
  severity: 'S1' | 'S2' | 'S3' | 'S4';
  description: string;
  detected_at: string;
  possible_causes?: string[];
  onCreateIncident?: (id: string) => void;
}

export function AnomalyCard({ id, metric, severity, description, detected_at, possible_causes, onCreateIncident }: AnomalyCardProps) {
  return (
    <div class="bg-gray-800 rounded-xl border border-gray-700 p-5 hover:bg-gray-750 transition-colors">
      <div class="flex items-start justify-between mb-3">
        <div class="flex items-center gap-3">
          <SeverityBadge severity={severity} />
          <div>
            <h3 class="text-white font-semibold text-sm">{metric}</h3>
            <span class="text-xs text-gray-400">{new Date(detected_at).toLocaleString('pt-BR')}</span>
          </div>
        </div>
      </div>
      <p class="text-sm text-gray-300 mb-3">{description}</p>
      {possible_causes && possible_causes.length > 0 && (
        <div class="mb-3">
          <span class="text-xs text-gray-500 font-medium">Causas possíveis:</span>
          <ul class="mt-1 space-y-1">
            {possible_causes.map((c, i) => (
              <li key={i} class="text-xs text-gray-400 flex items-center gap-1.5">
                <span class="w-1 h-1 bg-gray-500 rounded-full" />
                {c}
              </li>
            ))}
          </ul>
        </div>
      )}
      {onCreateIncident && (
        <Button variant="ghost"
          class="text-xs px-3 py-1.5 bg-red-600/20 text-red-400 rounded-lg hover:bg-red-600/30 transition-colors border border-red-600/30"
          onClick={() => onCreateIncident(id)}
        >
 Criar Incidente
        </Button>
      )}
    </div>
  );
}
